"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLicenseNursysTransactionUpdateStatusDto = instanceOfLicenseNursysTransactionUpdateStatusDto;
exports.LicenseNursysTransactionUpdateStatusDtoFromJSON = LicenseNursysTransactionUpdateStatusDtoFromJSON;
exports.LicenseNursysTransactionUpdateStatusDtoFromJSONTyped = LicenseNursysTransactionUpdateStatusDtoFromJSONTyped;
exports.LicenseNursysTransactionUpdateStatusDtoToJSON = LicenseNursysTransactionUpdateStatusDtoToJSON;
exports.LicenseNursysTransactionUpdateStatusDtoToJSONTyped = LicenseNursysTransactionUpdateStatusDtoToJSONTyped;
const NursysTransactionStatus_1 = require("./NursysTransactionStatus");
/**
 * Check if a given object implements the LicenseNursysTransactionUpdateStatusDto interface.
 */
function instanceOfLicenseNursysTransactionUpdateStatusDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('statusMessage' in value) || value['statusMessage'] === undefined)
        return false;
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function LicenseNursysTransactionUpdateStatusDtoFromJSON(json) {
    return LicenseNursysTransactionUpdateStatusDtoFromJSONTyped(json, false);
}
function LicenseNursysTransactionUpdateStatusDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': (0, NursysTransactionStatus_1.NursysTransactionStatusFromJSON)(json['status']),
        'statusMessage': json['statusMessage'],
        'data': json['data'],
    };
}
function LicenseNursysTransactionUpdateStatusDtoToJSON(json) {
    return LicenseNursysTransactionUpdateStatusDtoToJSONTyped(json, false);
}
function LicenseNursysTransactionUpdateStatusDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': (0, NursysTransactionStatus_1.NursysTransactionStatusToJSON)(value['status']),
        'statusMessage': value['statusMessage'],
        'data': value['data'],
    };
}
//# sourceMappingURL=LicenseNursysTransactionUpdateStatusDto.js.map